module.exports = __webpack_public_path__ + "static/media/ieeenitp.c0a7cceb.png";